import {
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import { React, useEffect, useState } from 'react';
import HelpIcon from '@mui/icons-material/Help';
import ReactTooltip from 'react-tooltip';

export default function BoxQuantOccurrencesSolved({ occurrences }) {

  const primeiro = {
    height: '140px',
    paddingTop: 5,
    backgroundColor: "#fff"
  };

  const [occurrencesSolved, setOccurrencesSolved] = useState([]);

  useEffect(() => {
    let filtred = occurrences.filter(item => {
      return ((item.status === "Resolvido" || item.status === "Indeferido"))
    })
    setOccurrencesSolved(state => filtred)
  }, [occurrences])

  return (
    <Card >
      <CardContent style={primeiro}>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}

        >
          <Grid item>
            <Typography
              className="box-title"
              gutterBottom
              variant="h6"
            >
              Ocorrências Atendidas
              <HelpIcon style={{ 'color': '#a1a5ab', marginTop: -7 }} fontSize="small" data-for="proportion-info" data-place="bottom" data-tip='Ocorrências Atendidas são as ocorrências "Resolvidas" e "Indeferidas".' />
              <ReactTooltip id="proportion-info" className='popup' />
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {occurrencesSolved.length}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
